import { useCallback } from "react";
import { Tags } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import useAuthorized from "hooks/useAuthorized";
import TagCategoryService from "services/TagCategory";
import TagCategoryForm from "./forms/TagCategoryForm";
import {
  invalidateTagCategoryTableQuery,
  useTagCategoryTable,
} from "hooks/useTagCategoryTable";

export const TAG_CATEGORY_TABLE_CONSTANTS = {
  tableName: "tag_categories",
  queryKey: "tag_category",
  className: "TagCategory",
  header: "Tag Categories",
  headerIcon: Tags,
};

const TagCategoryTableV3 = () => {
  const canCreate = useAuthorized([ACL_RELATIONSHIPS.tagCategory.create]);

  const { filters, columns } = useTagCategoryTable({
    tableName: TAG_CATEGORY_TABLE_CONSTANTS.tableName,
  });

  const fetchTagCategories = useCallback(
    queryParams =>
      TagCategoryService.getTagCategoriesTable(
        getNextQueryParams(queryParams, columns)
      ),
    [columns]
  );

  const createButton = canCreate ? (
    <FormDialog
      FormComponent={TagCategoryForm}
      modelType="Tag Category"
      onSuccess={invalidateTagCategoryTableQuery}
    />
  ) : null;

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={TAG_CATEGORY_TABLE_CONSTANTS.headerIcon}
      header={TAG_CATEGORY_TABLE_CONSTANTS.header}
      tableName={TAG_CATEGORY_TABLE_CONSTANTS.tableName}
      queryKey={TAG_CATEGORY_TABLE_CONSTANTS.queryKey}
      className={TAG_CATEGORY_TABLE_CONSTANTS.className}
      fetchData={fetchTagCategories}
      createButton={createButton}
      enableSearch
      enableSettings
      invalidateData={invalidateTagCategoryTableQuery}
    />
  );
};

export default TagCategoryTableV3;
